import styles from './screen.module.scss';
import Lottie from 'react-lottie';
import animationData from '@assets/Json/43_G.json';
import info from '@assets/SVG/info.svg';
import { Col, Image, Row } from 'antd';
import DateTime from './DateTime';
import Box from '@assets/SVG/Box.svg';
import GroupAmenities from '@assets/SVG/GroupAmenities.svg';
import pLine from '@assets/SVG/PLine.svg';

export default function JSignBoard() {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};

	return (
		<div>
			<Lottie options={defaultOptions} />
		</div>
	);
}

export const Screen5 = () => {
	return (
		<div
			className="screen7"
			style={{
				background: styles.blue,
				height: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width:"100%"
			}}
		>
			<div style={{ background: styles.blue }}>
				<div className="textVariantPotraitLarge">Selamat Datang ke Malaysia</div>
				<div className="textVariantPotraitLarge2">Welcome to Malaysia</div>
				<Row justify="center" gutter={30} align="middle">
					<Col lg={7} style={{ marginRight: '3rem' }}>
						<Image src={Box} preview={false} width={1100} height={1100} />
					</Col>
					<Col lg={6} style={{ textAlign: 'center', marginLeft: '4rem' }}>
						<div style={{ paddingLeft: '12rem' }}>
							<Image src={info} preview={false} />
							<div style={{marginTop:"15px"}} className="infoText">Kaunter Penerangan</div>
							<div style={{marginTop:"15px"}} className="infoText2">Information Counter</div>
						</div>
						<JSignBoard />
					</Col>
				</Row>
				<div>
					<Image style={{height:"4px",marginTop:"30px"}} src={pLine} preview={false} />
				</div>
				<div style={{ display: 'flex', justifyContent: 'center', margin: '80px 0px' }}>
					<Image src={GroupAmenities} preview={false} />
				</div>
				<div className="textVariantSectionSmall " style={{marginTop: "80px"}}>
					<DateTime />
				</div>
			</div>
		</div>
	);
};
